import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Paper, Typography, TextField, Button, Box, Alert } from '@mui/material';
import api from '../utils/api';
import Swal from 'sweetalert2';

const ResetPasswordPage = () => {
    const { token } = useParams(); // Prende il token dall'URL
    const navigate = useNavigate();
    
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError('Le password non coincidono.');
            return;
        }
        if (password.length < 8) {
             setError('La password deve essere di almeno 8 caratteri.');
            return;
        }

        setError('');
        setLoading(true);

        try {
            const response = await api.post(`/users/reset-password/${token}`, { password });
            await Swal.fire({
                title: 'Successo!',
                toast: true,
                position: 'top-end',
                text: response.message,
                icon: 'success'
            });
            navigate('/login'); // Reindirizza al login
        } catch (err) {
            setError(err.response?.data?.message || 'Si è verificato un errore.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="xs" sx={{ mt: 8 }}>
            <Paper elevation={3} sx={{ p: 4 }}>
                <Typography component="h1" variant="h5" align="center" gutterBottom>
                    Reimposta la tua Password
                </Typography>
                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                <Box component="form" onSubmit={handleSubmit}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Nuova Password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="confirmPassword"
                        label="Conferma Nuova Password"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                        disabled={loading}
                    >
                        {loading ? 'Aggiornamento...' : 'Aggiorna Password'}
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default ResetPasswordPage;